const ShopActionTypes = {
    FETCH_COLLECTION_START: 'FETCH_COLLECTION_START',
    FETCH_COLLECTION_SUCCESS: 'FETCH_COLLECTION_SUCCESS',
    FETCH_COLLECTION_FAILURE: 'FETCH_COLLECTION_FAILURE'
};

export default ShopActionTypes;